module.exports = __webpack_public_path__ + "img/TG300.png";